const globalSearchState = $state({
  highlight: JSON.parse(localStorage.getItem('perigovet-global-search-state'))?.highlight ?? true,
  globalScope: JSON.parse(localStorage.getItem('perigovet-global-search-state'))?.globalScope ?? true,
  fullScreen: JSON.parse(localStorage.getItem('perigovet-global-search-state'))?.fullScreen ?? false,
  settingsOpen: false, // We always want to start with the settings dropdown closed
  algoliaOnly: JSON.parse(localStorage.getItem('perigovet-global-search-state'))?.algoliaOnly ?? false
})

export default globalSearchState
